/**
 * Theme-owned Boost PFS hooks for simple-color grouping.
 * Keep this file out of Boost's overwrite set. boost-pfs-filter.js may call
 * these helpers, but this file also patches Boost prototypes so grouping
 * still works after a Boost theme-file sync.
 */
(function () {
  'use strict';

  window.MCO = window.MCO || {};
  if (window.MCO._boostHooksBound) return;
  window.MCO._boostHooksBound = true;

  function isReservedAllCollection() {
    if (typeof window.MCO_RESERVED_ALL_COLLECTION === 'boolean') {
      return window.MCO_RESERVED_ALL_COLLECTION;
    }

    // Fallback: Shopify's automated catalog only (id 0). A merchant
    // collection with handle "all" has a real id and should group.
    var collectionId = window.boostPFSConfig && window.boostPFSConfig.general
      ? window.boostPFSConfig.general.collection_id
      : null;
    return collectionId === 0 || collectionId === '0';
  }

  function mcoSimpleColorsEnabled() {
    if (isReservedAllCollection()) return false;
    return window.MCO_SIMPLE_COLORS_ENABLED === true;
  }

  function handleizeStyleKey(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function slugifyTitleBase(title) {
    if (!title) return '';
    return handleizeStyleKey(title.split(' - ')[0].trim());
  }

  function hasColorSuffixTitle(title) {
    return title && title.indexOf(' - ') !== -1;
  }

  function unwrapMetafieldValue(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'object') {
      if (value.value != null && value.value !== '') return String(value.value);
      return '';
    }
    return String(value);
  }

  function getMetafieldValue(data, key) {
    if (!data) return '';

    var metafields = data.metafields;
    if (Array.isArray(metafields)) {
      for (var i = 0; i < metafields.length; i++) {
        var field = metafields[i];
        if (!field) continue;
        var fieldKey = field.key || field.name || '';
        var fieldNs = field.namespace || '';
        if (fieldKey === key && (fieldNs === 'custom' || fieldNs === '')) {
          return unwrapMetafieldValue(field.value != null ? field.value : field);
        }
        if (fieldKey === 'custom.' + key || fieldKey === 'custom_' + key) {
          return unwrapMetafieldValue(field.value != null ? field.value : field);
        }
      }
    } else if (metafields && typeof metafields === 'object') {
      if (metafields.custom && metafields.custom[key] != null) {
        return unwrapMetafieldValue(metafields.custom[key]);
      }
      if (metafields['custom.' + key] != null) {
        return unwrapMetafieldValue(metafields['custom.' + key]);
      }
      if (metafields[key] != null) {
        return unwrapMetafieldValue(metafields[key]);
      }
      if (Array.isArray(metafields.nodes)) {
        return getMetafieldValue({ metafields: metafields.nodes }, key);
      }
    }

    if (data['custom.' + key] != null) return unwrapMetafieldValue(data['custom.' + key]);
    if (data['metafield_custom_' + key] != null) return unwrapMetafieldValue(data['metafield_custom_' + key]);
    if ((key === 'style_name' || key === 'simplecolor_sort') && data[key] != null) {
      return unwrapMetafieldValue(data[key]);
    }

    return '';
  }

  function isCollectionTemplatePage() {
    return document.body && document.body.classList.contains('template-collection');
  }

  function isColorCatalogProduct(data) {
    return !!(data && (getMetafieldValue(data, 'simplecolor_sort') || hasColorSuffixTitle(data.title)));
  }

  function buildMcoAttributes(data) {
    var sortValue = getMetafieldValue(data, 'simplecolor_sort');

    if (!mcoSimpleColorsEnabled()) {
      if (!isReservedAllCollection() && isColorCatalogProduct(data) && isCollectionTemplatePage()) {
        return ' data-mco-hide-on-default-collection="true"';
      }
      return '';
    }

    var titleBaseKey = slugifyTitleBase(data && data.title);
    if (!titleBaseKey) return '';

    var attrs = ' data-mco-title-base-key="' + titleBaseKey + '"';
    var styleName = getMetafieldValue(data, 'style_name');
    var styleKey = styleName ? handleizeStyleKey(styleName) : titleBaseKey;

    if (hasColorSuffixTitle(data.title) || sortValue) {
      attrs += ' data-mco-simple-color="true"';
      attrs += ' data-mco-product-id="' + data.id + '"';
      attrs += ' data-mco-style-key="' + styleKey.replace(/"/g, '&quot;') + '"';
      if (sortValue) attrs += ' data-mco-sort="' + sortValue + '"';
      if (styleName) attrs += ' data-mco-style-name="' + styleName.replace(/"/g, '&quot;') + '"';
    } else {
      attrs += ' data-mco-legacy-style-key="' + styleKey.replace(/"/g, '&quot;') + '"';
      attrs += ' data-mco-legacy-title-key="' + titleBaseKey + '"';
    }

    return attrs;
  }

  function injectAttributesOnRoot(html, attrs) {
    if (!html || !attrs) return html;
    return html.replace(/^\s*(<[a-zA-Z][\w:-]*)(\s|>)/, function (match, tag, after) {
      return after === '>' ? tag + attrs + '>' : tag + attrs + after;
    });
  }

  function alreadyHasMcoAttributes(html) {
    return html.indexOf('data-mco-simple-color') !== -1
      || html.indexOf('data-mco-title-base-key') !== -1
      || html.indexOf('data-mco-hide-on-default-collection') !== -1;
  }

  function enhanceBoostItemHtml(html, data) {
    if (html == null || html === '') return html;

    var attrs = buildMcoAttributes(data);
    if (html.indexOf('{{itemMcoAttributes}}') !== -1) {
      html = html.replace(/\{\{itemMcoAttributes\}\}/g, attrs);
    } else if (attrs && !alreadyHasMcoAttributes(html)) {
      html = injectAttributesOnRoot(html, attrs);
    }

    return html;
  }

  function hideSimpleColorProductsOnDefaultCollection() {
    if (isReservedAllCollection() || mcoSimpleColorsEnabled() || !isCollectionTemplatePage()) return;

    document.querySelectorAll('[data-mco-hide-on-default-collection="true"]').forEach(function (node) {
      var card = node.classList.contains('product__thumbnail') || node.classList.contains('thumbnail')
        ? node
        : node.closest('.product__thumbnail, .thumbnail');
      if (card) card.style.display = 'none';
    });
  }

  function initMcoCollectionSwatches() {
    if (!mcoSimpleColorsEnabled() || !window.MCO || typeof window.MCO.initSimpleColorSwatches !== 'function') {
      return;
    }

    var container = document.querySelector('.boost-pfs-filter-products.collection-matrix')
      || document.querySelector('.collection-matrix');
    if (!container) return;

    var productsPerRow = window.boostPFSConfig && window.boostPFSConfig.custom
      ? window.boostPFSConfig.custom.products_per_row
      : 3;
    var collectionMatrix = container.closest('[data-mco-collection-handle]') || container;

    window.MCO.initSimpleColorSwatches({
      container: container,
      productsPerRow: productsPerRow,
      collectionHandle: collectionMatrix.getAttribute('data-mco-collection-handle') || undefined
    });
  }

  function onBoostThemeReady() {
    initMcoCollectionSwatches();
    hideSimpleColorProductsOnDefaultCollection();
  }

  window.MCO.buildBoostItemAttributes = buildMcoAttributes;
  window.MCO.enhanceBoostItemHtml = enhanceBoostItemHtml;
  window.MCO.shouldHideBoostColorProduct = function (data) {
    return !isReservedAllCollection()
      && !mcoSimpleColorsEnabled()
      && isCollectionTemplatePage()
      && isColorCatalogProduct(data);
  };
  window.MCO.shouldSkipBoostVariantSwatches = function (data) {
    return mcoSimpleColorsEnabled() && isColorCatalogProduct(data);
  };
  window.MCO.onBoostThemeReady = onBoostThemeReady;
  window.MCO.initBoostCollection = onBoostThemeReady;

  function wrapMethod(ctor, methodName, wrapper) {
    if (!ctor || !ctor.prototype || typeof ctor.prototype[methodName] !== 'function') return false;
    var proto = ctor.prototype;
    if (proto[methodName]._mcoBoostPatched) return true;
    var original = proto[methodName];
    var patched = function () {
      return wrapper.call(this, original, arguments);
    };
    patched._mcoBoostPatched = true;
    proto[methodName] = patched;
    return true;
  }

  function patchBoostPrototypes() {
    var ProductGridItem = window.ProductGridItem;
    var ProductList = window.ProductList;

    wrapMethod(ProductGridItem, 'compileTemplate', function (original, args) {
      var data = args[0] || this.data;
      if (window.MCO.shouldHideBoostColorProduct(data)) return '';
      var html = original.apply(this, args);
      return enhanceBoostItemHtml(html, data);
    });

    wrapMethod(ProductList, 'afterRender', function (original, args) {
      var result = original.apply(this, args);
      onBoostThemeReady();
      return result;
    });

    return !!(ProductGridItem && ProductGridItem.prototype && ProductGridItem.prototype.compileTemplate);
  }

  var tries = 0;
  function bindWhenReady() {
    if (patchBoostPrototypes()) return;
    if (tries++ > 40) return;
    setTimeout(bindWhenReady, 50);
  }

  bindWhenReady();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      onBoostThemeReady();
    });
  }
})();
